<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 90vw">
      <div class="modal-header">
        <h5 class="modal-title">Add Patient Services</h5>
        <button type="button" @click="closeModal">X</button>
      </div>

      <div style="min-height: 50vh" class="modal-body">
        <div class="">
          <div class="mt-2  parent-div" style="overflow: visible">
            <div class="">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr style="color: black">
                    <th style="width: 50%">Service Name</th>
                    <th style="width: 25%">Cash Price</th>
                    <th style="width: 25%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(service, index) in services" :key="service.id">
                    <td style="position: relative; overflow: visible">
                      <div style="position: relative">
                        <input
                          type="text"
                          v-model="service.name"
                          @input="fetchServiceSuggestions(service)"
                          @focus="showSuggestions(service)"
                          @blur="hideSuggestions(service)"
                          placeholder="Type service name"
                          class="form-control"
                        />
                        <ul
                          v-if="
                            service.suggestions.length &&
                            service.showSuggestions
                          "
                          class="suggestions-list"
                        >
                          <li
                            v-for="suggestion in service.suggestions"
                            :key="suggestion.id"
                            @mousedown.prevent="
                              selectSuggestion(service, suggestion)
                            "
                          >
                            <div class="suggestion-item">
                              <span class="suggestion-name">{{
                                suggestion.name
                              }}</span>
                              <span class="suggestion-category">{{
                                suggestion.category_name || ""
                              }}</span>

                              <span class="suggestion-category">
                                {{ suggestion.cash_charge
                            ? formatCurrency(suggestion.cash_charge)
                            : '' }}
                              </span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <input
                        type="text"
                        :value="
                          service.cash_charge
                            ? formatCurrency(service.cash_charge)
                            : ''
                        "
                        class="form-control"
                        readonly
                        style="background-color: #f8f9fa"
                      />
                    </td>
                    <td>
                      <button
                        class="mycustom-danger-button"
                        @click="removeService(index)"
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <button class="mycustom-success-button mt-2" @click="addService">
                Add Another Service
              </button>
            </div>
          </div>
        </div>

        <div class="mt-4 text-end">
          <button class="mycustom-primary-button" @click="submitServices">
            Submit Services
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";

export default {
  name: "AddPatientServiceModal",
  props: {
    visitId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      services: [
        {
          id: Date.now(),
          name: "",
          suggestions: [],
          selected_service_id: null,
          cash_charge: null,
          showSuggestions: false,
        },
      ],
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-add-service-modal");
    },

    addService() {
      this.services.push({
        id: Date.now() + Math.random(),
        name: "",
        suggestions: [],
        selected_service_id: null,
        cash_charge: null,
        showSuggestions: false,
      });
    },

    removeService(index) {
      this.services.splice(index, 1);
    },

    showSuggestions(service) {
      if (service.suggestions.length > 0) {
        service.showSuggestions = true;
      }
    },

    hideSuggestions(service) {
      // Delay hiding to allow click event to fire first
      setTimeout(() => {
        service.showSuggestions = false;
      }, 200);
    },

    fetchServiceSuggestions(service) {
      // Reset selected service when user types
      service.selected_service_id = null;
      service.cash_charge = null;

      if (!service.name.trim()) {
        service.suggestions = [];
        service.showSuggestions = false;
        return;
      }

      const url = `search-medical-services?search=${service.name}`;
      generalApiRequest(url, "GET", {}, 1)
        .then((response) => {
          service.suggestions = response.data;
          service.showSuggestions = true;
        })
        .catch((error) => {
          console.error("Error fetching suggestions:", error);
        });
    },

    selectSuggestion(service, suggestion) {
      service.name = suggestion.name;
      service.selected_service_id = suggestion.id;
      service.cash_charge = suggestion.cash_charge;
      service.suggestions = [];
      service.showSuggestions = false;
    },

    formatCurrency(amount) {
      if (!amount) return "";
      return new Intl.NumberFormat("en-KE", {
        style: "currency",
        currency: "KES",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount);
    },

    async submitServices() {
      // Validate that all services have been selected
      const invalidServices = this.services.filter(
        (s) => !s.selected_service_id,
      );
      if (invalidServices.length > 0) {
        alert(
          "Please select valid services from the suggestions for all rows.",
        );
        return;
      }

      const payload = this.services.map((service) => ({
        medical_service_id: service.selected_service_id,
        quantity: 1,
        visit_id: this.visitId,
      }));

      try {
        const url = "services/create";
        await generalApiRequest(url, "POST", payload, 1);
        this.closeModal();
        location.reload();
      } catch (error) {
        console.error("Error submitting services:", error);
      }
    },
  },
};
</script>

<style scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th {
  background-color: #f8f9fa;
  padding: 12px;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  text-align: left;
}

.table td {
  padding: 10px 12px;
  border-bottom: 1px solid #dee2e6;
  vertical-align: top;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control[readonly] {
  cursor: default;
}

.suggestions-list {
  list-style: none;
  padding: 0;
  margin: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 250px;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  z-index: 9999;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.suggestions-list li {
  padding: 0;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

.suggestions-list li:last-child {
  border-bottom: none;
}

.suggestions-list li:hover {
  background: #e9ecef;
}

.suggestion-item {
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.suggestion-name {
  font-weight: 500;
  color: #333;
}

.suggestion-category {
  font-size: 12px;
  color: #6c757d;
  background: #f1f3f5;
  padding: 2px 8px;
  border-radius: 12px;
}

.mycustom-danger-button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.mycustom-danger-button:hover {
  background-color: #c82333;
}

.mycustom-success-button {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.mycustom-success-button:hover {
  background-color: #218838;
}

.mycustom-primary-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s;
}

.mycustom-primary-button:hover {
  background-color: #0056b3;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.mmodal-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden; /* Prevent horizontal scroll from absolutely positioned elements */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #dee2e6;
}

.modal-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.modal-header button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6c757d;
  padding: 4px 8px;
  border-radius: 4px;
}

.modal-header button:hover {
  background: #f1f3f5;
  color: #333;
}

.modal-body {
  padding: 24px;
  overflow: visible; /* Allow content to overflow */
}

/* Critical fix: Remove overflow hidden from parent containers */
.card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: visible !important; /* Allow suggestions to overflow card */
}

.parent-div {
  overflow: visible !important; /* Allow suggestions to overflow parent */
}

.text-end {
  text-align: end;
}

.mt-2 {
  margin-top: 8px;
}

.mt-4 {
  margin-top: 24px;
}
</style>
